import { ErrorHandler, Provider, inject } from '@angular/core';
import { LoggingService } from '../logging.service';
import { SucheError } from './suche-error';

export class NowSucheErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggingService);
  handleError(error: Error) {
    if (error instanceof SucheError) {
      this.logger.error(error);
    }
  }
}

export function provideNowErrorHandler(): Provider {
  return { provide: ErrorHandler, useClass: NowSucheErrorHandler };
}
